import { Component } from '@angular/core';
import { Save } from 'lucide-angular';
import { UserModel } from '../shared/user.model';
import { UserService } from '../shared/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AbstractEntityEditComponent } from '@app/shared/abstract/abstract-entity-edit.component';
import { ButtonComponent } from '@app/partials/form/button/button.component';
import { SelectComponent } from '@app/partials/form/select/select.component';
import { TextInputComponent } from '@app/partials/form/text-input/text-input.component';
import { VenueService } from '@app/venues/shared/venue.service';
import { RouteParams } from '@app/shared/abstract/route-params';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-edit',
  imports: [ButtonComponent, ReactiveFormsModule, SelectComponent, TextInputComponent],
  templateUrl: './user-edit.component.html',
  styleUrl: './user-edit.component.css',
})
export class UserEditComponent extends AbstractEntityEditComponent {
  protected processing = false;
  protected validationErrors: string[] = [];
  protected user: UserModel;
  protected readonly SaveIcon = Save;

  roleChoices = [
    // { value: 'admin', label: 'Admin' },
    { value: 'manager', label: 'Manager' },
    { value: 'staff', label: 'Staff' },
    { value: 'admin', label: 'Admin' },
  ];

  form = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(50)]),
    email: new FormControl('', [Validators.required, Validators.maxLength(255)]),
    second_email: new FormControl('', [Validators.maxLength(255)]),
    password: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(50)]),
    role: new FormControl<string>('', [Validators.required]),
    // venues: new FormControl<number[]>([], Validators.required),
  });

  // protected venueChoices: Observable<{ label: string; value: number | null }[]>;

  constructor(
    private userService: UserService,
    // private venueService: VenueService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    super();

    this.form.valueChanges.subscribe((value: any) => {
      if (this.form.dirty && !this.form.valid) {
        this.validationErrors = this.getFormValidationErrors(this.form);
      }
    });

    // this.venueChoices = this.venueService
    //   .getPage(new RouteParams({ pageSize: 1000, pageNum: 1 }))
    //   .pipe(map((res) => res.data.map((item) => ({ value: item.id, label: item.name }))));

    if (this.route.snapshot.data['user']) {
      this.user = this.route.snapshot.data['user'];
      this.form.patchValue(this.user as any);
      if (this.user.roles) {
        this.form.get('role')?.setValue(this.user.roles[0]);
      }
      this.form.get('password')?.clearValidators();
      // this.form.controls['venues'].setValue(this.user.venues.map((venue) => venue.id as number));
    } else {
      this.user = {} as UserModel;
      this.form.patchValue(this.user as any);
    }
  }

  save() {
    if (this.form.invalid) {
      return;
    }
    this.processing = true;

    // const venues = this.form.get('venues')?.value || [];
    const data = {
      id: this.user.id || null,
      created_at: this.user.created_at || null,
      updated_at: this.user.updated_at || null,
      name: this.form.get('name')?.value,
      email: this.form.get('email')?.value,
      second_email: this.form.get('second_email')?.value,
      password: this.form.get('password')?.value || null,
      roles: [this.form.get('role')?.value],
      // venues: venues,
    };

    this.userService.save(data as unknown as UserModel).subscribe({
      next: (res) => {
        if (!this.user.id) {
          this.router.navigate(['/users']);
        } else {
          this.processing = false;
          this.user = res.data;
          this.form.patchValue(this.user as any);
          this.router.navigate(['/users/' + this.user.id + '/edit']);
          // this.form.controls['venues'].setValue(this.user.venues.map((venue) => venue.id as number));
          this.form.markAsPristine();
        }
      },
      error: (res) => {
        if (res.status === 422) {
          AbstractEntityEditComponent.bindErrorsToForm(res.error, this.form);
        }
        this.processing = false;
      },
    });
  }

  cancel() {
    return this.router.navigate(['/users']);
  }
}
